//src/LoadingSpinner.tsx
import { cn } from "@/lib/utils";

interface LoadingSpinnerProps {
  className?: string;
}

export default function LoadingSpinner({ className }: LoadingSpinnerProps) {
  return (
    <div className={cn("animate-spin w-8 h-8 border-4 border-[hsl(193,100%,50%)] border-t-transparent rounded-full", className)} aria-label="Loading" />
  );
}
